import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentClickedService {
  clicked: Subject<HTMLElement> = new Subject<HTMLElement>();
}
